import { render } from "./IconMentalHealth.vue?vue&type=template&id=b0ba78a2"
import script from "./IconMentalHealth.vue?vue&type=script&lang=js"
export * from "./IconMentalHealth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__